import { useAtomValue } from 'jotai';
import { useParams } from 'react-router-dom';

import { useTranslate } from '@growtherapy/i18n';

import { useGetTelehealthSessionInfo } from '../../hooks';
import { useEnterWaitingRoomCallback } from '../nav/useEnterWaitingRoomCallback';
import { VisitorState, visitorNameAtom, visitorStateAtom } from '../state';
import { Page } from './Page';

export function PageWrapper() {
  const t = useTranslate();
  const { providerShortId, patientShortId } = useParams();
  const { data } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const visitorState = useAtomValue(visitorStateAtom);
  const enterWaitingRoom = useEnterWaitingRoomCallback();
  const visitorName = useAtomValue(visitorNameAtom);

  return (
    <Page
      providerName={data?.telehealthSessionInfo?.provider.name ?? t('telehealth-core:rejoin.yourProvider')}
      isTimeout={visitorState === VisitorState.TIMEOUT}
      onRejoin={() => {
        enterWaitingRoom(visitorName);
      }}
    />
  );
}
